// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"48":"72ae9a6e","920":"3869d992","996":"c27841b1"}[chunkId] + ".chunk.css";
};